<script>
	import { getContext, onMount } from 'svelte'
	import DraggableComponent from '@Components/DraggableComponent.svelte'
	import { on } from 'svelte/events'
	import { getIconHtml } from '@Utils/Icons.js'
	let { visible = false } = $props()
	const { getEditorCanvas, isDev, getController } = getContext('editor')
	let controller = getController()
	let editorCanvas = getEditorCanvas()
	let tooltipEl
	let followMouse = false
	let followMouseTooltip = null
	let isDarkMode = $state(window.isDarkMode)
	window.addEventListener('colorSchemeChanged', (e) => {
		isDarkMode = e.isDarkMode
	})
	onMount(() => {
		document.addEventListener('mousemove', (e) => {
			if (!tooltipEl) {
				return
			}
			if (followMouse) {
				tooltipEl.style.top = `${e.clientY + 10}px`
				tooltipEl.style.left = `${e.clientX + 10}px`
				if (followMouseTooltip) {
					tooltipEl.innerHTML = followMouseTooltip
					tooltipEl.style.visibility = 'visible'
					tooltipEl.style.opacity = '1'
				} else {
					tooltipEl.style.opacity = '0'
					tooltipEl.style.visibility = 'hidden'
					tooltipEl.innerHTML = ''
				}
			}
		})
		document.addEventListener('mouseover', (e) => {
			if (!tooltipEl) {
				return
			}
			if (!followMouse) {
				let tooltip = e.target.getAttribute('tooltip')
				let tooltipBackground = e.target.getAttribute('tooltip-background')
				if (!tooltip && tooltipEl.style.opacity === '0') {
					return
				}
				if (!tooltip) {
					tooltipEl.style.opacity = '0'
					tooltipEl.style.visibility = 'hidden'
					tooltipEl.innerHTML = ''
				} else {
					let offset = 0
					if(e.target.dataset.tooltipOffset) {
						offset = parseInt(e.target.dataset.tooltipOffset,10)
					}
					tooltipEl.innerHTML = tooltip
					tooltipEl.style.visibility = 'visible'
					tooltipEl.style.opacity = '1'
					let targetRect = e.target.getBoundingClientRect()
					let tooltipElRect = tooltipEl.getBoundingClientRect()
					let left = targetRect.left - tooltipElRect.width / 2 + targetRect.width / 2
					let margin = 10 + offset
					let top = targetRect.top - tooltipElRect.height - margin
					let bottom = targetRect.top + targetRect.height + margin
					if (left + tooltipElRect.width + margin > document.body.clientWidth) {
						left = document.body.clientWidth - tooltipElRect.width - margin
					}
					tooltipEl.style.top = `${top - tooltipElRect.height > margin ? top : bottom}px`
					tooltipEl.style.left = `${left >= margin ? left : margin}px`
					if (tooltipBackground) {
						tooltipEl.style.backgroundColor = tooltipBackground
					} else {
						tooltipEl.style.backgroundColor = null
					}
				}
			}
		})
	})

	editorCanvas.on('currentToolChange', function (t, el) {
		if (t === 'measure') {
			followMouse = true
		} else {
			followMouse = false
			followMouseTooltip = null
		}
	})
	editorCanvas.on('measurementUpdated', function (measurement) {
		if (measurement) {
			followMouseTooltip = measurement.output.formatted
		} else {
			followMouseTooltip = null
		}
	})
</script>

<div bind:this={tooltipEl} class="tooltip"></div>

<style lang="postcss">
	.tooltip {
		user-select: none;
		transition: opacity 0.2s ease-in-out;
		font-size: 13px;
		font-weight: bold;
		z-index: 100;
		content: attr(title);
		position: absolute;
		height: auto;
		background-color: theme('colors.bigsteel.900');
		border-radius: 8px;
		padding: 8px;
		color: white;
	}
</style>
